export default {
  'register.fullName': 'Full name',
  'register.button.account': 'Register',
};
